module.exports = __webpack_public_path__ + "img/bih_logo.1ac89f00.png";